<template>
  <button :disabled="disabled || isButtonLoading" :type="buttonType" :class="className" @click="handleSubmit">
    {{ buttonText }}
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

defineProps({
  className: {
    type: String,
    default: ''
  },
  buttonText: {
    type: String,
    default: '',
    required: true
  },
  buttonType: {
    type: String,
    default: 'button'
  },
  handleSubmit: {
    type: Function,
    required: true
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});

const store = useStore();

const isButtonLoading = computed(() => store.getters['common/isButtonLoading']);
</script>
